import { useMutation } from '@tanstack/react-query';
import useApi from './useApi';

type PolicyItem = {
  policyCode: string;
  applied: boolean;
};

type CaseEligibilityPolicyPayload = {
  caseId: number;
  policies: PolicyItem[];
};

const useCaseEligibilityPolicyMutation = () => {
  const { Api } = useApi();

  return useMutation({
    mutationFn: async ({ caseId, policies }: CaseEligibilityPolicyPayload) => {
      const responses = await Promise.all(
        policies.map(({ policyCode, applied }) => Api.referrers.postEligibilityPolicy(caseId, policyCode, applied))
      );

      return responses.map((res) => res?.data);
    }
  });
};

export default useCaseEligibilityPolicyMutation;
